<template>
  <bottom-bar class="vip-detail-bottom-bar"
              :benefit-bar="benefitBar"
              :sell="sell"
              :product="formatProduct"
              :render-price="renderPrice"
              :action-bar="actionBar"
              :my-team-id="myTeamId"
              my-team-bar-type="black-gold"
  >
    <template #left>
      <gift-btn class="join-bottom-bar-item"
                :show="showGift"
                :id="product.id"
                :disabled="disabledGift"
                @click="handleClickGift"
      />
    </template>
    <entrance v-if="showEntrance" />
  </bottom-bar>
</template>

<script>
  import validator from '@/utils/validator';
  import BottomBar from '@/components/ProductDetailBottom/Bar';
  import GiftBtn from '@/pages/Vip/components/VipGiftBtn';
  import Entrance from '@/pages/Vip/components/VipEntrance';

  export default {
    name: 'VipDetailBottomBar',
    components: {
      BottomBar,
      GiftBtn,
      Entrance,
    },
    props: {
      benefitBar: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      showGift: Boolean,
      disabledGift: Boolean,
      showConsult: Boolean,
      showEntrance: Boolean,
      sell: {
        type: Object,
        required: true,
      },
      product: {
        type: Object,
        required: true,
      },
      renderPrice: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      actionBar: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      myTeamId: {
        type: Number,
        default: 0,
      },
    },
    methods: {
      handleClickGift() {
        this.$emit('click-gift');
      },
    },
    computed: {
      formatProduct() {
        return Object.assign(this.product, { type: 'vip' });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .vip-detail-bottom-bar {
    flex: 1;

    .join-bottom-bar-item {
      margin-left: -@size-base;
    }
    /deep/ .vip-entrance {
      margin-left: @size-base;
    }
  }

</style>
